module.exports = __webpack_public_path__ + "logo.png?fed359a78a8f59e6822826ed5e34253e";